var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"approvePass"},[_c('Form',{ref:"formValidate",attrs:{"model":_vm.passModel,"label-position":"top"}},[_c('comForm',{attrs:{"formItemData":_vm.mainFormItemData,"formModel":_vm.passModel,"onlyView":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }